import axios from 'axios';

export const loadMenu = async ({ commit, getters }) => {
    // TODO put correct url
    if (getters.menuUrl)
        return axios.get(getters.menuUrl)

            .then(data => {
                if (data) {
                    const menu = data.data;
                    if (menu != null)
                        commit('SET_MENU', menu.data);
                }
            });
}